import { render } from "./Main.vue?vue&type=template&id=bb6ccee8&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=bb6ccee8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bb6ccee8"

export default script